import { ipify, posts } from '../Utils/Axios'
import * as actionTypes from './actionTypes'

export const updateField = (name, value) => {
    return {
        type: actionTypes.UPDATE_FIELD,
        name: name,
        value: value
    }
}

export const submit = () => {
    return (dispatch, getState) => {
        ipify.get().then(response => send(getState().guest, response.data.ip, dispatch))
    }
}

const send = (message, ip, dispatch) => {
    return posts.post("/posts.json", {
        message: message.message,
        ip: ip, 
        date: Date.now()
    }).then(response => {
        dispatch({
            type: actionTypes.SUBMIT,
            status: 'OK'
        })
    }).catch(error => {
        dispatch({
            type: actionTypes.SUBMIT,
            status: 'KO'
        })
    })
}